<!--
 * @FileDescription: 员工管理model（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-06-12（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-06-3（最后更新时间）
 -->
<template>
    <div>
        <a-modal  class="department-model" :title="title1"  v-model="isShowModel1"  @ok="onCofrimForm1"  @cancel="onCancel">
            <a-form :form="form1"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 16 }"
                    class="display-flex"
            >
                <div class="form-left">
                    <a-form-item label="员工姓名">
                        <a-input placeholder="请输入员工姓名"
                                 v-decorator="['name', { rules: [{ required: true, message: '请输入员工姓名' }] }]" />
                    </a-form-item>
                    <a-form-item label="员工电话">
                        <a-input placeholder="请输入员工电话"  :maxLength="11"
                                 v-decorator="['mobile', { rules: [{ required: true, message: '请输入员工电话' }] }]" />
                    </a-form-item>
                    <a-form-item label="入职日期">
                        <a-date-picker @change="onChangeData" placeholder="请选择入职日期"    v-decorator="['entryDate', { rules: [{ required: false,message:'请选择入职时间' }] }]"/>
                    </a-form-item>
                    <a-form-item label="部门">
                        <a-select  v-decorator="['departId',{ rules: [{ required: false}] },]"
                                   placeholder="请选择部门"
                        >
                            <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                            <a-select-option v-for="item in companyList" :key="item.id">{{item.name}} </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="员工地址">
                        <a-input placeholder="请输入员工地址"  :maxLength="11"
                                 v-decorator="['address', { rules: [{ required: false }] }]" />
                    </a-form-item>
                    <a-form-item label="身份证号">
                        <a-input placeholder="请输入员工身份证号" :maxLength="18"
                                 v-decorator="['idNumber', { rules: [{ required: false }] }]" />
                    </a-form-item>
                    <a-form-item label="薪资待遇">
                        <a-input placeholder="请输入薪资待遇"
                                 v-decorator="['salary', { rules: [{ required: false }] }]" />
                    </a-form-item>
                    <a-form-item label="照片">
                        <v-picture :imgUrlProp="picUrl"  :isRemarks="false" @onChangeImg="onChangeImg"></v-picture>
                    </a-form-item>
                </div>

                <div class="form-left">
                    <a-form-item label="员工工号">
                        <a-input placeholder="请输入员工工号"
                                 v-decorator="['code', { rules: [{ required: false }] }]" />
                    </a-form-item>
                    <a-form-item label="专业">
                        <a-input placeholder="请输入专业名称"
                                 v-decorator="['profession', { rules: [{ required: false }] }]" />
                    </a-form-item>
                    <a-form-item label="出生年月" style="padding-right: 10px">
                        <a-month-picker  @change="onChangeData1" placeholder="请选择出生年月"   v-decorator="['birth', { rules: [{ required: false}] }]"/>
                    </a-form-item>
                    <a-form-item label="性别">
                        <a-radio-group   v-decorator="['gender', { rules: [{ required: false }] }]">
                            <a-radio value="1">男</a-radio>
                            <a-radio value="2">女</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="籍贯">
                        <a-input placeholder="请输入员工籍贯"
                                 v-decorator="['birthplace', { rules: [{ required: false }] }]" />
                    </a-form-item>
                    <a-form-item label="学历">
                        <a-select  v-decorator="['education',{ rules: [{ required: false}] },]"
                                   placeholder="请选择"
                        >
                            <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                            <a-select-option  v-for="(item, index) in configList" :key="item.id">{{item.value}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="是否正式">
                        <a-radio-group  v-decorator="['regularFlag', { rules: [{ required: false }] }]">
                            <a-radio value="0">实习</a-radio>
                            <a-radio value="1">正式</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="状态">
                        <a-radio-group  v-decorator="['state', { rules: [{ required: false }] }]">
                            <a-radio value="1">在职</a-radio>
                            <a-radio value="2">离职</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="入职合同">
                        <div class="down-up" v-if="isEmpty(attachmentUrl)">
                            <template v-if="isEmpty(attachmentResourceId)">
                                <a-icon type="upload" class="down-up-icon" />
                                <span style="color: #555555">上传附件</span>
                                <v-upload @onChangeFile="onChangeFile"></v-upload>
                            </template>
                            <template v-else>
                                <span>上传附件成功</span>
                            </template>
                        </div>
                        <div class="down-up" v-else @click="handleExport(attachmentUrl)">
                            <a-icon type="download" class="down-up-icon" />
                            <span  style="color: #555555">下载附件</span>
                        </div>
                    </a-form-item>
                </div>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import {AddDepart,getfindDepart,saveStaff,updateStaff,configType} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";
    import moment from 'moment';
    import picture from "@/components/upload/picture.vue"
    import upload from '@/components/upload/upload.vue'
    import pick from 'lodash.pick'
    export default {
        mixins:[mixins],
        props:{
            index:{
                type:Number,
                default:1
            },
            companyList:{
                type:Array,
            },
        },
        data(){
            return{
                title1:'新增员工',
                form: this.$form.createForm(this),
                isShowModel1:false,
                form1: this.$form.createForm(this),
                model:{},
                picUrl:{},
                datetime1:'',
                datetime:'',
                picurlid:'',
                attachmentResourceId:'',
                attachmentUrl:'',
                stateIndex:1,
                configList:[]
            }
        },
        watch: {
        },
        mounted () {
            this.configTypeList()
        },
        created () {

        },
        components: {
            'v-picture': picture,
            'v-upload':upload,
        },
        methods: {
            moment,
            onCancel(){
                this.isShowModel = false
                this.isShowModel1 = false
            },
            onOpen(){
                this.isShowModel = true
            },
            onOpen1(record,index){
                this.stateIndex = index
                this.picUrl = {}
                if(this.isEmpty(record.name)){
                    record.regularFlag = "1"
                    record.state = "1"
                    record.gender = "1"
                }
                this.form1 = this.$form.createForm(this)
                this.model = Object.assign({},record)
                this.attachmentResourceId = ''
                this.attachmentUrl = ''

                this.isShowModel1 = true
                if(index == 1){
                    this.$nextTick(() => {
                        this.form1.setFieldsValue(pick(this.model,'state','regularFlag','gender'))
                    });
                }else{
                    this.$nextTick(() => {
                        console.log(this.model)
                        this.form1.setFieldsValue(pick(this.model,'name','mobile','code','state','regularFlag','address','birth','entryDate','pictureUrl',
                            'birthplace','departId','education','idNumber','salary','profession','gender','id','attachmentFlag','attachmentUrl','pictureResourceId'
                        ))
                        this.form1.setFieldsValue({entryDate:this.model.entryDate?moment(this.model.entryDate):null})
                        this.form1.setFieldsValue({birth:this.model.birth?moment(this.model.birth):null})
                        this.attachmentUrl = this.model.attachmentUrl
                        this.attachmentResourceId = this.model.attachmentResourceId
                        this.picUrl = {
                            url:this.model.pictureUrl,
                            id:this.model.pictureResourceId
                        }
                    });
                }
            },
            /**
             * @description: 学历（方法描述）
             */
            configTypeList(){
                let data = new FormData()
                data.append('type',1)
                configType(data,{}).then((res)=>{
                    if(res.success){
                        this.configList = res.result
                    }
                })
            },
            /**
             * @description: 保存（方法描述）
             */
            onCofrimForm1(){
                this.form1.validateFields((err, values) => {
                    if(!err){
                        if(this.isEmpty(this.datetime)){
                            values.entryDate = this.model.entryDate
                            values.birth = this.model.birth
                        }else{
                            values.entryDate = this.datetime
                            values.birth = this.datetime1
                        }
                        values.pictureResourceId = this.picurlid
                        values.companyStoreId = this.$store.state.shopId
                        values.companyId = this.$store.state.companyId
                        values.attachmentResourceId = this.attachmentResourceId
                        console.log(values,this.model)
                        if(this.stateIndex == 1){
                            saveStaff(values,{}).then((res)=>{
                                if(res.success){
                                    this.isShowModel1 = false
                                    this.$message.success(res.logMessage)
                                    this.$emit('saveStaff')
                                }else{
                                    this.$message.warn(res.logMessage)
                                }
                            })
                        }else{
                            values.id = this.model.id
                            updateStaff(values,{}).then((res)=>{
                                if(res.success){
                                    this.isShowModel1 = false
                                    this.$message.success(res.logMessage)
                                    this.$emit('saveStaff')
                                }else{
                                    this.$message.warn(res.logMessage)
                                }
                            })
                        }
                    }
                })
            },
            /**
             * @description: 入职日期（方法描述）
             */
            onChangeData(date, dateString){
                console.log(date,dateString)
                this.datetime = dateString
            },
            /**
             * @description: 出生年月（方法描述）
             */
            onChangeData1(date, dateString){
                this.datetime1 = dateString
            },
            /**
             * @description: 上传文件（方法描述）
             */
            onChangeFile(file){
                this.attachmentResourceId = file.id

            },
            onChangeImg(id){
                this.picurlid = id
            },
            handleExport(url){
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                // link.setAttribute('download',  fileName +'.xls')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            },
        },

    }
</script>
<style lang="scss">
    .department-model{
        width: 800px !important;
        height: 800px !important;
        .ant-calendar-picker{
            width: 230px;
        }
    }
</style>
<style scoped lang="scss">

.form-left{
    margin-right: 40px;
    flex: 1;
}
.form-left:last-child{
    margin-right: 0;
}
.display-flex{
  padding: 0 20px;
}
.down-up{
    width:120px;
    height:36px;
    background:rgba(250,250,250,1);
    border:1px solid rgba(230,230,230,1);
    border-radius:2px;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
